import type { Theme } from '@emotion/react';
import type { Appearance, StripeElementsOptions } from '@stripe/stripe-js';

export const getStripeAppearance = (theme: Theme): Appearance => {
    return {
        rules: {
            '.Checkbox': {
                color: theme.isLightColorScheme ? theme.colors.gray[500] : theme.colors.white,
                fontSize: '14px'
            },
            '.Input': {
                borderColor: theme.colors.gray[300],
                borderRadius: '4px'
            },
            '.Input:focus': {
                borderColor: theme.colors.brand.primary,
                borderWidth: '2px',
                boxShadow: 'none'
            },
            '.Label': {
                color: theme.isLightColorScheme ? theme.colors.gray[500] : theme.colors.white,
                fontSize: '16px'
            }
        },
        theme: theme.isLightColorScheme ? 'stripe' : 'night',
        variables: {
            colorPrimary: theme.colors.brand.primary,
            fontFamily: 'open-sans, sans-serif'
        }
    };
};

export const getStripeFonts = (staticUrl: string): StripeElementsOptions['fonts'] => [
    {
        family: 'open-sans',
        src: `url(${staticUrl}/common/font/OpenSans-Regular.woff)`,
        weight: '400'
    },
    {
        family: 'open-sans',
        src: `url(${staticUrl}/common/font/OpenSans-SemiBold.woff)`,
        weight: '600'
    },
    {
        family: 'open-sans',
        src: `url(${staticUrl}/common/font/OpenSans-Bold.woff)`,
        weight: '700'
    }
];
